<template>
  <div class="wrap">
    <div class="title">
      产品规格
    </div>
    <div class="tab">
      <span class="tab-t">
        标准型
      </span>
    </div>
    <div class="img">
      <img
        src="https://platform-cloud.zhongseyun.com/galileo/202309/8430990f21db442ab330104772d88462.png"
        alt=""
      />
    </div>
    <div class="info tc">
      中色云产品
    </div>
    <div class="tip tc">
      中色云服务
    </div>
    <div class="btn tc">
      <el-button round class="b" @click="goto">立即购买</el-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Instance",
    components: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {
      goto(){
        window.open('//platform-cloud.zhongseyun.com/product/select-purchase-info?productType=11&productId=2&classValue=403')
      }
    },
  };
</script>
<style scoped>
  .tc {
    text-align: center;
  }
  .title {
    font-size: 28px;
    font-weight: 700;
    color: #212224;
    letter-spacing: 0;
    text-align: center;
    padding-top: 72px;
    margin-bottom: 34px;
  }
  .tab {
    text-align: center;
  }
  .tab-t {
    padding: 12px 0;
    color: #005fe1;
    text-shadow: 0 0 0.25px currentcolor;
    border-bottom: 2px solid #005fe1;
  }
  .img {
    text-align: center;
    margin-top: 50px;
  }
  .info {
    padding: 70px 0 25px;
    font-size: 20px;
    color: #212224;
    letter-spacing: 0.15px;
  }
  .tip {
    font-size: 13px;
    color: #9fa3a7;
    letter-spacing: 0;
    line-height: 20px;
    margin-bottom: 30px;
  }
  .b {
    box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.06);
  }
</style>
